module.exports = __webpack_public_path__ + "static/media/buy_interview_10.4e662a33.jpg";